{
    "AppMenu_AppsTitle": "Menu",
    "AppMenu_Apps_Reporting": "Analyses",
    "AppMenu_Apps_FastProvisioning": "Snelle provisioning",
    "AppMenu_Apps_Administration": "Administratie",
    "AppMenu_Apps_StatusAndTools": "Status en hulpmiddelen",
    "AppMenu_FavouritesTitle": "Favorieten",
    "NAME": "AppMenu"
}